import { createAction } from 'spw-redux/types';
import { IProjectSettings } from './types';

export const FETCH_PROJECT_SETTINGS = 'settings/FETCH_PROJECT_SETTINGS';
export const FETCH_PROJECT_SETTINGS_SUCCEEDED =
  'settings/FETCH_PROJECT_SETTINGS_SUCCEEDED';
export const SET_PROJECT_SETTINGS = 'settings/SET_PROJECT_SETTINGS';

export const fetchProjectSettings = () => createAction(FETCH_PROJECT_SETTINGS);
export const fetchProjectSettingsSucceeded = (
  projectSettings: IProjectSettings
) => createAction(FETCH_PROJECT_SETTINGS_SUCCEEDED, { projectSettings });

export const setProjectSettings = (projectSettings: IProjectSettings) =>
  createAction(SET_PROJECT_SETTINGS, { projectSettings });

export const actions = {
  fetchProjectSettings,
  setProjectSettings,
  fetchProjectSettingsSucceeded,
};
